<template>
  <div
    class="row row-inside separator-int"
    v-if="devis"
  >
    <div class="flex md1">
      <b>{{ devis.nb_devis }}</b>
      <div class="flex md12 ma-0 pa-0">
        <va-button
          class="button-comments"
          small
          outline
          :color="devis.nbcomments ? 'success' : 'info'"
          @click="showComments = !showComments"
        >Commentaires</va-button>
      </div>
    </div>
    <div class="flex md2">
      {{ devis.nom }}
    </div>
    <div class="flex md1">
      {{ moment(devis.date_creation).format("DD/MM/YYYY") }}
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth kitmedia"
        color="gray"
        disabled
      >Kit Média</va-button>
    </div>
    <div class="flex md1 col-pos">
      <va-button
        class="fullwidth"
        :color="devis.date_envoi ? 'success' : 'info'"
        @click="dispDevis()"
      >Devis
        {{
          devis.date_envoi
            ? moment(devis.date_envoi, "YYYY-MM-DD").format("DD/MM/YYYY")
            : ""
        }}</va-button>
    </div>
    <div class="flex md1 col-pos">{{ devis.montant }} €</div>

    <div class="flex md1">
      <va-button
        class="fullwidth kitmedia"
        :color="devis.date_validation ? 'success' : 'info'"
        @click="showUpload = true"
      >{{ validationTexte }}</va-button>
    </div>
    <div class="flex md2">
      <div class="row row-inside">
        <div
          class="flex md2"
          v-for="(element, index) in devis.listJournal"
        >
          <b>{{ element.numero ? element.numero : "HS-XX" }}</b>
        </div>
      </div>
    </div>
    <div class="flex md2">
      {{ devis.uname_attribution }}
    </div>
    <div
      class="flex md12 mb-3 mt-0 pt-0"
      v-if="showComments"
    >
      <devis-comments-list
        class="relance-container-list"
        :iddevis_publications="devis.iddevis_publication"
        setheight="15"
      />
    </div>
    <devis-visualisation
      :iddevis="devis.iddevis_publication"
      v-model="showVisDevis"
      v-on:modify="openEdit"
    />
    <devis-modification
      :iddevis="devis.iddevis_publication"
      v-model="showEditDevis"
      v-on:modified="reloadList"
    />
    <upload-devis
      :iddevis="devis.iddevis_publication"
      v-model="showUpload"
      v-on:update="reloadList"
      :entrepriseName="devis.nom"
    />

    <va-modal
      class="modal"
      v-model="showWaiting"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <va-progress-circle
        indeterminate
        color="info"
      />
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import DevisVisualisation from "./devisVisualisation";
import DevisModification from "./devisModification";
import moment from "moment";
import DevisCommentsList from "./devisCommentsList";
import UploadDevis from "./uploadDevis";

export default {
  name: "devis-list-line",
  props: ["devis"],
  components: {
    DevisVisualisation,
    DevisModification,
    DevisCommentsList,
    UploadDevis,
  },

  data() {
    return {
      moment: moment,
      showUpload: false,
      showComments: false,
      annonce: null,
      paid: false,
      showVisDevis: false,
      showEditDevis: false,
      showFacture: false,
      dateFacture: moment().format("DD-MM-YYYY"),
      showDeleteConfirm: false,
      showWaiting: false,
    };
  },

  created() { },
  mounted() { },
  computed: {
    validationTexte() {
      if (this.devis.date_validation) {
        return (
          "Validé le " +
          moment(this.devis.date_validation, "YYYY-MM-DD").format("DD/MM/YYYY")
        );
      } else {
        return "En attente";
      }
    },
  },
  methods: {
    montantProp(annonce) {
      let montant = annonce.montant;
      let remise = (annonce.montant * annonce.remise) / 100;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return montant - remise - remise_fixe;
    },
    annulerFacture() {
      this.showDeleteConfirm = true;
    },
    async deleteFacture() {
      try {
        this.showWaiting = true;
        let params = { idfacture: this.annonce.idfacture };
        await axios.delete("/api/publications/facture", { params: params });
        this.launchEpicmaxToast("Facture supprimé");
        this.showFacture = false;
        this.showDeleteConfirm = false;
        this.showWaiting = false;
        this.getAnnonce();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la suppression");
        this.showWaiting = false;
      }
    },
    async getFacture() {
      try {
        this.showWaiting = true;
        let resTmp = await axios.get("/api/publications/facture", {
          params: { idfacture: this.annonce.idfacture },
        });
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération de la facture");
        this.showWaiting = false;
      }
    },
    async editFacture() {
      try {
        this.showWaiting = true;
        let params = {
          idannonce: this.idannonce,
          dateFacture: moment(this.dateFacture, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
        };

        let resTmp = await axios.post("/api/publications/facture", params);
        this.getAnnonce();
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'édition de la facture");
        this.showWaiting = false;
      }
    },
    openFactureEditor() {
      this.showFacture = false;
      this.showFacture = true;
    },
    reloadList() {
      this.$emit("reloadList", this.devis.iddevis_publication);
    },
    openEdit(iddevis) {
      this.showVisDevis = false;
      this.showEditDevis = true;
    },
    dispDevis() {
      this.showEditDevis = false;
      if (!this.showVisDevis) {
        this.showVisDevis = true;
      } else {
        this.showVisDevis = false;
        this.showVisDevis = true;
      }
    },
    async changeAttribution() { },
    attributionMessage(annonce) {
      if (!annonce.idutilisateur_attribution) {
        return "Non attribué";
      }

      return annonce.nom_complet;
    },
    attributionColor(annonce) {
      if (!annonce.idutilisateur_attribution) {
        return "info";
      }
      if (
        annonce.idutilisateur_attribution ===
        this.$store.getters.user.idutilisateurs
      ) {
        return "success";
      }
      return "danger";
    },

    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.fullwidth {
  width: 95%;
  font-size: 0.8em;
}

.kitmedia {
  font-size: 0.8em;
}

.col-pos {
  text-align: center;
}
.centered {
  padding-left: 15%;
}

.separator-int {
  border-bottom: 1px solid #ccc;
}

.button-comments {
  margin: 5px 0;
  padding: 1px 5px;
}
</style>
